// Testing cards
// https://developers.braintreepayments.com/guides/3d-secure/migration/javascript/v3#client-side-sandbox-testing

export const TEST_CARD = {
  number: '4111111111111111',
  cardHolder: 'Test test',
  expirationMonth: '01',
  expirationYear: '27',
  cvv: '000',
  postalCode: '123',
}

// 3ds testing cards
// https://developers.braintreepayments.com/guides/3d-secure/testing-go-live/php#testing
export const TEST_CARD_NO_CHALLENGE = {
  ...TEST_CARD,
  number: '4000000000001000',
}

export const TEST_CARD_NO_CHALLENGE_FAIL = {
  ...TEST_CARD,
  number: '5200000000001013',
}

export const TEST_CARD_ERROR = {
  ...TEST_CARD,
  number: '5200000000001120',
}
